import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { RESET_LOADER, SET_LOADER } from "../../../constants/contexConstant";
import {
    ACCOUNT_TYPE,
    PAYMENT_OPTIONS,
} from "../../../constants/proposalConstants";
import { ADMIN_GET_COMMUNE_INVSETMENT } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import request from "../../../services/request";
import Button from "../../../shared/ui/Button";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import { FormRadioGroup } from "../../../shared/ui/Form/FormRadioGroup";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import { communeInvestmentSchema } from "../../../shared/ui/Form/schema";

const CommuneInvestmentForm = ({ onSuccess, url }) => {
    const urlString = new URL(url);
    const code = urlString.searchParams.get("code");
    const { dispatch } = useContextState();
    const [isDisabled, setIsDisabled] = useState(false);
    const [initialValues, setInitialValues] = useState({
        llpName: "",
        paymentCollection: "DIRECT_PAYMENT",
        bankAccountName: "",
        bankAccountNumber: "",
        bankAccountType: "SAVINGS",
        razorpayTransferAccount: "",
    });

    const fetchCommuneInvestment = async () => {
        try {
            dispatch({ SET_LOADER });
            let endpoint = `${ADMIN_GET_COMMUNE_INVSETMENT}/${code}`;
            let response = await request.authGet({
                endpoint,
            });
            if (response?.status === "SUCCESS" && response?.data?.data) {
                const data = response.data.data;

                setInitialValues({
                    llpName: data?.llpName || "",
                    paymentCollection:
                        data?.paymentCollection || "DIRECT_PAYMENT",
                    bankAccountName: data?.bankAccountName || "",
                    bankAccountNumber: data?.bankAccountNumber || "",
                    bankAccountType: data?.bankAccountType || "SAVINGS",
                    razorpayTransferAccount:
                        data?.razorpayTransferAccount || "",
                });

                setIsDisabled(true);
                dispatch({ RESET_LOADER });
            }
        } catch (error) {
            dispatch({ RESET_LOADER });
        }
    };
    useEffect(() => {
        fetchCommuneInvestment();
    }, []);

    const handleSubmit = (values) => {
        onSuccess(values);
    };

    return (
        <div className="p-4 xs:pb-2 overflow-y-scroll font-vietnam bg-white">
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={communeInvestmentSchema}
                onSubmit={handleSubmit}
            >
                {({ values }) => (
                    <Form className="space-y-2">
                        <FormikLabeledInput
                            label="LLP Name"
                            name="llpName"
                            required
                            disabled={isDisabled}
                        />

                        <FormRadioGroup
                            name="paymentCollection"
                            label="Payment Collection"
                            wrapperClass="flex-col"
                            optionContainerClass="gap-2 md:gap-5"
                            options={PAYMENT_OPTIONS.map((opt) => ({
                                value: opt.value,
                                label: opt.label,
                                subLabel: opt.subLabel,
                            }))}
                            disabled={isDisabled}
                        />

                        <FormikLabeledInput
                            label="Bank Account Name"
                            name="bankAccountName"
                            required={
                                values.paymentCollection === "PAYMENT_GATEWAY"
                            }
                            disabled={isDisabled}
                        />

                        <FormikLabeledInput
                            label="Bank Account Number"
                            name="bankAccountNumber"
                            required
                            disabled={isDisabled}
                        />

                        <LabeledFormikSelect
                            label="Bank Account Type"
                            name="bankAccountType"
                            options={ACCOUNT_TYPE}
                            required
                            disabled={isDisabled}
                        />
                        {values.paymentCollection === "PAYMENT_GATEWAY" && (
                            <FormikLabeledInput
                                label="Razorpay Transfer Account"
                                name="razorpayTransferAccount"
                                required={
                                    values.paymentCollection ===
                                    "PAYMENT_GATEWAY"
                                }
                                disabled={isDisabled}
                            />
                        )}

                        <Button
                            type="submit"
                            className="w-full"
                            disabled={isDisabled}
                        >
                            Submit LLP Details
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default CommuneInvestmentForm;
